(function () {
  var STORAGE_KEY = 'ed_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, fail silently */
    }
  }

  function isLiked(id) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function toggle(product) {
    var list = getWishlist();
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(product.id)) {
        idx = i;
        break;
      }
    }
    var liked;
    if (idx > -1) {
      list.splice(idx, 1);
      liked = false;
    } else {
      list.push(product);
      liked = true;
    }
    saveWishlist(list);
    updateBadge();
    return liked;
  }

  function remove(id) {
    var list = getWishlist().filter(function (item) {
      return String(item.id) !== String(id);
    });
    saveWishlist(list);
    updateBadge();
  }

  function updateBadge() {
    var count = getWishlist().length;
    var bubbles = document.querySelectorAll('.wishlist-count-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      var bubble = bubbles[i];
      var span = bubble.querySelector('[data-wishlist-count]');
      if (count > 0) {
        bubble.hidden = false;
        if (span) span.textContent = count > 99 ? '99+' : count;
      } else {
        bubble.hidden = true;
      }
    }
  }

  function syncButtonState(id, liked) {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-product-id') === String(id)) {
        buttons[i].classList.toggle('is-liked', liked);
        buttons[i].setAttribute('aria-pressed', liked ? 'true' : 'false');
      }
    }
  }

  function applyInitialStates(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var id = btn.getAttribute('data-product-id');
      var liked = isLiked(id);
      btn.classList.toggle('is-liked', liked);
      btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    }
  }

  function fireToggle(btn) {
    var product = {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      url: btn.getAttribute('data-product-url'),
      price: btn.getAttribute('data-product-price'),
    };
    if (!product.id) return;
    var liked = toggle(product);
    syncButtonState(product.id, liked);
  }

  /* Primary path: normal DOM target lookup (works when nothing is
     overlapping the button). */
  function onDocumentClick(e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      fireToggle(btn);
      return;
    }

    /* Fallback path: some themes place an invisible full-card overlay
       link on top of card contents (to make the whole card clickable),
       which can win the hit-test even when our button has a higher
       z-index. If the click landed inside ANY wishlist button's actual
       rendered rectangle, treat that as the real target regardless of
       what e.target reports, so the heart still works and the card
       doesn't navigate away underneath it. */
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var rect = buttons[i].getBoundingClientRect();
      if (
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom
      ) {
        e.preventDefault();
        e.stopPropagation();
        fireToggle(buttons[i]);
        return;
      }
    }
  }

  document.addEventListener('click', onDocumentClick, true);

  window.Wishlist = {
    getAll: getWishlist,
    isLiked: isLiked,
    toggle: toggle,
    remove: remove,
    updateBadge: updateBadge,
    initButtons: applyInitialStates,
  };

  function init() {
    applyInitialStates();
    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    applyInitialStates();
    updateBadge();
  });
})();
